import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AnalyticsService } from '../shared/services/fb-analytics.service';

@Component({
  selector: 'app-four04',
  templateUrl: './four04.component.html',
  styleUrls: ['./four04.component.scss']
})
export class Four04Component implements OnInit {
  private router = inject(Router);

  path: string;
  homeURL: string;

  constructor(
    private analyticsService: AnalyticsService
  ) { }

  returnHome($event?: Event): void {
    if ($event)
      this.analyticsService.trackInput($event);

    if (this.path.startsWith('/blog')) {
      this.homeURL = '/blog';
    } else {
      this.homeURL = '/';
    }
  }

  // Lifecycle Hooks

  ngOnInit(): void {
    this.path = this.router.url;
    this.analyticsService.setHtmlMeta(
      this.analyticsService.metaInfo.four04.title,
      this.analyticsService.metaInfo.four04.description
    )
  }

}
